export class monitorElement {
  tagThresholdMappingId: number;
  alertTypeId: any;
  condition: string;
  dataSourceId: number;
  frequency: number;
  monitoringCollectionId: any;
  parameterName: string;
  recipient: any;
  thresholdTypeId: number;
  thresholdValue: string;
  userId: string;

  constructor() {
    this.tagThresholdMappingId = 0;
    this.alertTypeId = null;
    this.condition = '';
    this.dataSourceId = 0;
    this.frequency = 0;
    this.monitoringCollectionId = null;
    this.parameterName = '';
    this.recipient = '';
    this.thresholdTypeId = 0;
    this.thresholdValue = '';
    this.userId = '';
  }
}

export class dataSource {
  DatasourceId: number;
  Name: string;

  constructor() {
    this.DatasourceId = 0;
    this.Name = '';
  }
}

export interface criteriaType {
  ThresholdTypeId: number;
  Name: string;
}
